<template>
  <div>
    <div
      class="modal fade"
      :id="idModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="deleteModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title text-uppercase"
              id="deleteModalLabel"
              style="color: red !important"
            >
              Modal Hapus
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeModalDelete"
            ></button>
          </div>
          <div class="modal-body text-uppercase">
            <p>Apa kamu yakin ingin menghapus data ini ?</p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Tidak
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="yesDelete"
            >
              Ya Hapus
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    idModal: {
      type: String,
      default: "deleteModal",
    },
    data: {
      type: Object,
      default: () => {}, // Gunakan fungsi untuk mengembalikan array kosong secara default
    },
    images: {
      type: Array,
      default: () => [], // Gunakan fungsi untuk mengembalikan array kosong secara default
    },
  },
  methods: {
    yesDelete() {
      if (this.images.length > 0) {
        this.$emit("saveDelete", {
          images: this.images,
          closeModal: this.$refs.closeModalDelete,
        });
      }
      if (this.images.length < 1) {
        this.$emit("saveDelete", {
          data: this.data,
          closeModal: this.$refs.closeModalDelete,
        });
      }
    },
  },
};
</script>
